import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from 'core'
import createStore from 'core/store'
import { history, createLocationUpdater } from 'browser-location'
import { pspVerificationResponse, secure3dResponse, cancelSecure3d } from 'credit-cards/actions'
import featureToggles from 'shared/featureToggles'

const store = createStore()

history.listen(createLocationUpdater(store))

window.notifyOfIngenicoResponse = (details, errors) => store.dispatch(pspVerificationResponse(details, errors))
window.notifyOfSecure3DResponse = (details, errors) => store.dispatch(secure3dResponse(details, errors))
window.notifyOfSecure3DClosed = () => store.dispatch(cancelSecure3d())

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <App history={history} />
        </Provider>,
        document.getElementById('root')
    )
}
if (featureToggles.hasHotModuleReplacement) {
    if (module.hot) {
        module.hot.accept('./core', () => {
            render()
        })

        module.hot.accept('./core/store', () => {
            render()
        })
    }
}

if ('fetch' in window && 'Intl' in window) {
    render()
} else {
    import('./polyfills').then(render)
}
